<app-dialog
        [dialogWithInput]="dialog">
    <app-create-update-default  (entityLoaded)="entityLoaded($event)"
                                [formGroup]="formGroup"
                                [id]="dialog.input.id"
                                [service]="service"
                                [hideSaveButton]="true"
                                [findOneService]="findOneService"
                                [inDialog]="true"
                                (entitySaved)="entitySaved($event)"
                                #createUpdateDefaultComponent>
        <ng-template template-content>
            <app-medical-record-sport-save-form #form [entity]="entity"
                                                [formGroup]="formGroup"
                                                [id]="dialog.input.id"
                                                [partnerId]="partnerId"
                                                [consultationId]="dialog.input.consultationSummary?.id"
                                                [audioTranscriptionConfig]="audioTranscription"></app-medical-record-sport-save-form>
        </ng-template>
    </app-create-update-default>
    <ng-container dialog-actions>
        <app-loading [loading]="createUpdateDefaultComponent.saveLoading" [showText]="false"></app-loading>
        <app-button (click)="executeSave()" [disabled]="!formGroup.valid" fill="solid" color="primary"
                    iconName="check" label="Enregistrer" *ngIf="!createUpdateDefaultComponent.saveLoading &&
                !createUpdateDefaultComponent.loading && !createUpdateDefaultComponent.findOneError"></app-button>
    </ng-container>
</app-dialog>
